import isBlank from './isBlank';

const save = (name, blob) => {
  return navigator.msSaveBlob
    ? navigator.msSaveBlob(blob, name)
    : saveGenericBrowser(blob, name);
};

const saveGenericBrowser = (blob, name) => {
  const a = document.createElement('a');

  return 'download' in a && !!download(a, name, URL.createObjectURL(blob));
};

const download = (a, name, url) => click(asDownload(a, name, url));

const asDownload = (a, name, url) => {
  a.setAttribute('href', url);
  a.setAttribute('download', name);
  a.style.visibility = 'hidden';

  return a;
};

const createCsv = rows => new Blob([processFile(rows)], { type: 'text/csv;charset=utf-8;' });

const click = el => {
  document.body.appendChild(el);
  el.click();

  return document.body.removeChild(el);
};

const processFile = rows => rows.map(processRow).join('\n');

const processRow = row => row.map(processValue).join(',');

const processValue = value => isBlank(value) ? '' : formatValue(value.toLocaleString());

const formatValue = value => value.match(',') ? `"${value}"` : value;

export default (name, rows) => save(name, createCsv(rows));
